// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"costAmt": 0,
		"detailsVOS": [
			{
				"apllyAmt": 0,
				"invyId": 0,
				"purcType": 0
			}
		],
		"invoDate": "",
		"phayId": 0,
		"purcInvoCodg": "",
		"remarks": "",
		"saleAmt": 0,
		"shedId": 0,
		"state": 0
	}
]

